//Loader
window.addEventListener('DOMContentLoaded', (event) => {
  var buylistItems = document.body.querySelectorAll('*[href="#buylist"]');
  buylistItems.forEach(function (buylistItem) {
    buylistItem.addEventListener("click", function (e) {
      e.preventDefault();
      buildBuylistOverlay();
    });
  });
});

//Buylist
var overlayStyle = 'position: fixed; top: 0; right: 0; z-index: 999999999; width: 85%; height: 100%; background: rgba(0,0,0,0.75);';
var iframeDivStyle = 'text-align: center; position: absolute; width: 100%; height: 100%;';
var closeStyle = 'color:white; position: absolute; top: 8px; left: 3px; height: 3rem; width:3rem; cursor: pointer; font-size: 22px';

function buylistIsInstalled() {
  return window.binderPOSBuylist && window.binderPOSBuylist.portalUrl && window.binderPOSBuylist.portalUrl.length > 0;
}

function buildBuylistOverlay() {
  var currentOverlay = document.querySelector("binderpos-buylist-overlay");
  if (!currentOverlay && buylistIsInstalled()) {
    var buylistOverlay = document.createElement('div');
    buylistOverlay.id = 'binderpos-buylist-overlay';
    buylistOverlay.setAttribute('style', overlayStyle);

    buylistOverlay.addEventListener('click', e => {
      if (e.target == buylistOverlay) {
        removeElement(buylistOverlay);
      }
    });

    var iframeContainer = document.createElement('div');
    iframeContainer.id = 'binderpos-buylist-iframe-container';
    iframeContainer.setAttribute('style', iframeDivStyle);

    iframeContainer.addEventListener('click', e => {
      if (e.target == iframeContainer) {
        removeElement(buylistOverlay);
      }
    })

    var iframeClose = document.createElement('div');
    iframeClose.setAttribute('style', closeStyle);

    var iframeIcon = document.createElement("i");
    iframeIcon.className = "fa fa-times-circle";
    iframeClose.appendChild(iframeIcon);

    iframeClose.addEventListener('click', e => {
      if (e.target == iframeClose || e.target == iframeIcon) {
        removeElement(buylistOverlay);
      }
    })

    iframeContainer.appendChild(iframeClose);

    var iframeContent = document.createElement('iframe');
    iframeContent.className = "binderpos-buylist-iframe";
    iframeContent.setAttribute('style', 'width: 1px !important; min-width: 100%;');
    iframeContent.setAttribute('height', '100%');
    iframeContent.setAttribute('scrolling', 'no');
    iframeContent.setAttribute('frameborder', 0);
    iframeContent.setAttribute('allowfullscreen', 'true');
    iframeContent.src = window.binderPOSBuylist.portalUrl;

    iframeContainer.appendChild(iframeContent);

    buylistOverlay.appendChild(iframeContainer);

    document.body.appendChild(buylistOverlay);
  } else {
    console.log("Buylist not installed");
  }

  function removeElement(node) {
    node.parentNode.removeChild(node);
  }
}